import { IBookingScheduler } from '../../models'
import { BaseHttpService } from './base'

class BookingSchedulerService extends BaseHttpService {
  public getBookingSchedulers = async (): Promise<IBookingScheduler[]> => {
    return this.get('booking-schedulers/user')
  }

  public addBookingScheduler = async (bookingScheduler: IBookingScheduler): Promise<any> => {
    return this.post('booking-schedulers', bookingScheduler)
  }

  public editBookingScheduler = async (bookingScheduler: IBookingScheduler): Promise<any> => {
    return this.put('booking-schedulers', bookingScheduler)
  }

  public removeBookingScheduler = async (id: number): Promise<any> => {
    return this.delete(`booking-schedulers/${id}`)
  }
}

export default new BookingSchedulerService()
